"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = Header;
exports.Content = Content;
exports.Footer = Footer;
const react_1 = __importDefault(require("react"));
const HelperUtils_1 = require("utils/HelperUtils");
const SVGIcon_1 = __importDefault(require("components/shared/SVGIcon"));
function QuestionComposer({ children, customClass }) {
    return (react_1.default.createElement("div", { className: `min-w-[720px] bg-n-200 border border-solid border-n-400 rounded-[4px]
      ${customClass || ''}` }, children));
}
function Header({ children, title, onCopy, onDelete, isReadOnly }) {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        children && children,
        !children && (react_1.default.createElement("div", { className: "flex justify-between items-center px-[24px] py-[16px]" },
            react_1.default.createElement("span", { className: "typography-h500 text-n-900" }, title),
            react_1.default.createElement("div", { className: "flex" },
                react_1.default.createElement("div", { className: `flex items-center mr-[24px] ${isReadOnly
                        ? 'text-n-600 cursor-not-allowed'
                        : 'text-base-600 cursor-pointer'}`, onClick: onCopy, "data-cy": `copy-question-${title}` },
                    react_1.default.createElement(SVGIcon_1.default, { size: 24, iconName: "icon-content_copy", fillColor: isReadOnly ? 'var(--n-600)' : 'var(--base-600)', customClass: "mr-[8px]" }),
                    (0, HelperUtils_1.getObjectiveLocale)('Copy')),
                react_1.default.createElement("div", { className: `flex items-center ${isReadOnly
                        ? 'text-n-600 cursor-not-allowed'
                        : 'text-base-600 cursor-pointer'}`, onClick: onDelete, "data-cy": `delete-question-${title}` },
                    react_1.default.createElement(SVGIcon_1.default, { size: 24, iconName: "icon-delete", fillColor: isReadOnly ? 'var(--n-600)' : 'var(--base-600)', customClass: "mr-[8px]" }),
                    (0, HelperUtils_1.getObjectiveLocale)('Delete')))))));
}
function Content({ children }) {
    return (react_1.default.createElement("div", { className: "border-0 border-t border-solid border-n-400" }, children));
}
function Footer({ children }) {
    return (react_1.default.createElement("div", { className: "border-0 border-t border-solid border-n-400" }, children));
}
exports.default = QuestionComposer;
